import { defineMessages } from 'react-intl';
import { addSchemaField } from 'iovisit-theme/config';

const messages = defineMessages({
  title: {
    id: 'Titolo',
    defaultMessage: 'Titolo',
  },
  show_block_bg: {
    id: 'Mostra lo sfondo del blocco',
    defaultMessage: 'Mostra lo sfondo del blocco',
  },
  image_bg: {
    id: 'Immagine di sfondo',
    defaultMessage: 'Immagine di sfondo',
  },
  color_title: {
    id: 'Colore del titolo',
    defaultMessage: 'Colore del titolo',
  },
});

/** DEFAULT **/

const getDefaultSchema = (schema, formData, intl, position = 0) => {
  let pos = position;
  addSchemaField(
    schema,
    'title',
    intl.formatMessage(messages.title),
    null,
    null,
    pos,
  );
  pos++;

  addSchemaField(
    schema,
    'show_block_bg',
    intl.formatMessage(messages.show_block_bg),
    null,
    { type: 'boolean' },
    pos,
  );
  pos++;

  addSchemaField(
    schema,
    'image_bg',
    intl.formatMessage(messages.image_bg),
    null,
    { widget: 'object_browser', mode: 'image', allowExternals: false },
    pos,
  );
  pos++;

  addSchemaField(
    schema,
    'color_title',
    intl.formatMessage(messages.color_title),
    null,
    {
      widget: 'color_list',
      colors: [
        { name: 'black', label: 'Nero' },
        { name: 'white', label: 'Bianco' },
      ],
      defaultValue: 'black',
    },
    pos,
  );
  pos++;

  return pos;
};

export default getDefaultSchema;
